export default [
  // 1
  {
    type: 'intro',
    header: {
      title: 'INTRODUCTION TO COACHING PROCESS',
      description: [
        {
          type: 'normal',
          content:
              ` The following Coaching process is a highly successful approach to
              executive development with a strong emphasis on the involvement of coworkers and
              measuring leadership effectiveness as perceived by these coworkers.
              It is effective, transparent, structured and
              a time-efficient process that works as follows:`,
        },
      ],
      media: '',
    },
    bodyType: '',
    bodies: [
      {
        type: 'ul',
        list: [
          {
            title: 'Coach Selection',
            content:
                ` Before you begin your journey to become a better leader,
                you will be given an opportunity to select the perfect coach for you.
                All coaches are world-class executive coaches and the best in the industry.
                You can access information on their education, their professional background,
                testimonials of clients they’ve worked with,
                and book introductory sessions with a couple of coaches
                before making your decision with who to select.`,
          },
          {
            title: 'Leadership Growth Areas',
            content:
                ` Once you’ve selected your coach,
                together you will pick two areas to focus on that will move
                you closer to realizing your leadership vision. In our experience,
                leadership development is best achieved when you focus on just
                a couple of areas for development and do them well.
                Your coach will then help you determine HOW to bridge the gap
                between today and your future aspirations.`,
          },
          {
            title: 'Involving Coworkers',
            content:
                ` Leadership is not about us.
                It’s about those we lead: our direct reports,our peers, and even our managers.
                These coworkers are the people who should ultimately recognize
                when we’ve become better leaders.
                The next step will be about proactively improving the perception of
                you as a leader. This is accomplished by asking your coworkers
                for suggestions on how you can improve your leadership based on your
                two focus areas and measuring changes in their perception of
                your effectiveness on a quarterly basis.`,
          },
        ],
      },
    ],
    replenish:
        `Your coach will be with you every step of the way and
        will play an integral role in the process.
        Please click below to begin your Coach selection process.`,
    buttons: [
      {
        type: 'primary',
        title: 'Select my Coach',
        key: 'route:coach',
      },
      {
        type: 'secondary',
        title: 'Close',
        key: 'close:',
      },
    ],
  },
  // 2
  {
    type: 'coach',
    header: {
      title: 'HOW TO CHOOSE YOUR COACH',
      description: [],
      media: '',
    },
    bodyType: '',
    bodies: [
      {
        type: 'text',
        list: [],
        text: [
          {
            type: 'normal',
            title: '',
            content:
                `All coaches have been vetted, trained,
                and assessed to ensure only the highest quality coaches are available to you.
                Although each coach is guaranteed to deliver high quality services,
                you may want to interview a few coaches to determine with which person
                you feel most comfortable. Building rapport will take time,
                but you can learn about our coaches by taking a few minutes
                to meet them before choosing one. Take a look at some coach profiles and
                schedule introductory sessions with a few you want to meet.
                Our objective here is for you to be paired with the best possible coach
                to support your growth.`,
          },
        ],
      },
    ],
    replenish: '',
    buttons: [
      {
        type: 'primary',
        title: 'Select my Coach',
        key: 'route:coach',
      },
      {
        type: 'secondary',
        title: 'Close',
        key: 'close:',
      },
    ],
  },
  // 3
  {
    type: 'feed',
    header: {
      title: 'HOW FEEDFORWARD IS COLLECTED',
      description: [],
      media: '',
    },
    bodyType: '',
    bodies: [
      {
        type: 'text',
        list: [],
        text: [
          {
            type: 'normal',
            title: '',
            content:
                ` Once your coworkers have been confirmed,
                they will receive an email inviting them to provide suggestions on
                how you can improve in your leadership growth areas.
                They will be asked to describe the actionable behaviors
                they believe will lead to an improvement in your leadership effectiveness.
                You can access these suggestions in the Feedforward page,
                where you will be able to review the comments with your coach
                and construct an action plan. This process will be a core element of
                each coaching session, ensuring that you have clarity on exactly
                how to make powerful improvements in your leadership effectiveness.`,
          },
        ],
      },
    ],
    replenish: '',
    buttons: [
      {
        type: 'primary',
        title: 'Close',
        key: 'close:',
      },
    ],
  },
  // 4
  {
    type: 'para',
    header: {
      title: 'PARADIGMS OF SUCCESSFUL PEOPLE',
      description: [],
      media: '',
    },
    bodyType: 'clear',
    bodies: [
      {
        type: 'text',
        list: [],
        text: [
          {
            type: 'normal',
            title: '',
            content:
                `In our mission to help successful people become great leaders,
                we’ve made an important discovery.
                We learned that some of the same beliefs that lead us to
                success can get in the way of making the necessary changes to increase that success.
                In fact, our research shows that successful people share 3 basic paradigms.
                Each of these paradigms help leaders reach a high degree of success,
                but simultaneously make it difficult to achieve the next level of success..
                These paradigms are:`,
          },
        ],
      },
      {
        type: 'circle',
        list: [
          {
            text: 'I am successful',
          },
          {
            text: 'I choose to succeed',
          },
          {
            text: 'I will be successful',
          },
        ],
        text: [],
      },
      {
        type: 'text',
        list: [],
        text: [
          {
            type: 'normal',
            title: '',
            content:
              `The more aware leaders are of both the advantages and the pitfalls of these beliefs,
              the more they can harness their power and steer themselves towards greater levels of
              success.`,
          },
        ],
      },
      // Paradigm 1
      {
        type: 'text',
        list: [],
        text: [
          // Paradigm 1-1
          {
            type: 'normal',
            title: 'PARADIGM 1 - I am successful',
            content:
              `The self-confidence of a leader often gives off a contagious,
                charismatic image to others.
                When a person sees themselves as a ‘winner in the game of life,’
                they are able to build the courage necessary to apply their abilities and
                strengths to their work.
                As the “I am successful” belief is positively correlated with a willingness to take
                necessary risks and make decisions,
                the leader relies on this self-confidence to reach his position of leadership.`,
          },
          // 1-2
          {
            type: 'normal',
            title: '',
            content:
              `This belief can, however, impede their growth. Consider this.
                Compared to the performance of your peers and others in your organization,
                how would you rate yourself? Would you say you are in the top 1% of performers?
                Maybe 10 or 20%? How about the top 30%? If you haven’t said yes yet,
                would you say you are in the top 50% of people in your organization?`,
          },
          // 1-3
          {
            type: 'normal',
            title: '',
            content:
              `We have asked this question to over a hundred thousand people around the world and
                the results are astonishing: about 70% of people say they are in the top 10% of
                their professional peer group and 82% think they’re in the top 20.
                About 98.5% believe they are in the top half, while < 2% are in the bottom half.`,
          },
          // 1-4
          {
            type: 'normal',
            title: '',
            content:
              `Believing that you are in the top 10% of your peer group can result in confidence
                that is essential in good leadership - it is crucial for leaders to exude competence
                 and certainty. The problem, however, is that arrogance can come into play.
                 If you believe you are in the top 10% of your peer group,
                 it is difficult to accept feedback from the remaining 90%.
                 It is easier to only accept feedback that is consistent with the way
                 we see ourselves and deny or reject feedback
                 that is inconsistent with our self-view. In other words,
                 successful leaders tend to confuse correlation with causation.
                 The truth is, they may not be successful because of their behavior but
                 in spite of their behavior.`,
          },
          // 1-5
          {
            type: 'normal',
            title: '',
            content:
              `Surgeons are a shining example of how this paradigm
                can negatively impact others we actually want to help.
                Research conducted by Harvard Medical professor, Dr. Atul Gawande,
                found that when surgeons invite nurses to ask a series of very simple questions
                before surgery, the odds on preventable infection plummet and the death rate due to
                preventable infections are drastically reduced. The problem?
                Most surgeons were unwilling to let the nurse ask the questions.
                Despite knowing what they should do, their overconfidence, stemming from the belief
                “I am successful,” leads them to assume they do not need help from others.`,
          },
        ],
      },
      // Table 1
      {
        type: 'table',
        title: 'Takeaways',
        columns: [
          'Advantages',
          'Pitfalls',
        ],
        data: [
          [
            'Positive self-image',
            'Tendency to over-rate performance',
          ],
          [
            'Courage to apply their strengths',
            'Difficulty accepting validity of feedback inconsistent with self-image',
          ],
          [
            'Contagious confidence and charisma',
            'May discount opinions of others who do not match their level of success',
          ],
        ],
      },
      // Table text 1-1
      {
        type: 'text',
        list: [],
        text: [
          {
            type: 'normal',
            title: '',
            content:
              `The good news about this belief is the inherent sense of self-assurance that is
              required to excel as a leader.
              The bad news is that the potential arrogance that accompanies the belief restricts
              the leaders’ ability to improve. The unwillingness to seek out, hear,
              or act on others’ input about their leadership then becomes the barrier to achieving
              the next level of success.`,
          },
        ],
      },
      // Table text 1-2
      {
        type: 'text',
        list: [],
        text: [
          {
            type: 'normal',
            title: '',
            content:
              `This sense of self-confidence, if applied to behavioral change,
              can be a powerful driver of success.
              It will help leaders get out of their comfort zone to ask for suggestions from others.
              When it comes to change: there’s little growth in the comfort zone,
              and there’s little comfort in the growth zone.`,
          },
        ],
      },
      // Paradigm 2
      {
        type: 'text',
        list: [],
        text: [
          // Paradigm 2-1
          {
            type: 'normal',
            title: 'PARADIGM 2 - I choose to succeed',
            content:
              `This paradigm has to do with a strong internal locus of control.
              Successful people have a strong need to make their choices and
              not leave them to others - to choose with their own will,
              rather than being commanded to take action.`,
          },
          // 2-2
          {
            type: 'normal',
            title: '',
            content:
              `Leaders with this paradigm are very committed and responsible workers.
              Once their mind is set on a goal, they will stop at nothing to achieve it.
              This persistence and unwillingness to give up earns admiration from peers,
              and creates a sense of ownership and personal accountability that propels them
              to succeed.`,
          },
          // 2-3
          {
            type: 'normal',
            title: '',
            content:
              `The downside of this paradigm is that this same commitment and
              persistence can get in the way of their ability to listen to and
              implement suggestions chosen by others.
              As successful people must come to their own conclusions and
              ultimately make their own decisions, they may resist the opinions,
              viewpoints, and observations that do not align with their own.`,
          },
        ],
      },
      // Table 2
      {
        type: 'table',
        title: 'Takeaways',
        columns: [
          'Advantages',
          'Pitfalls',
        ],
        data: [
          [
            'Self-determination',
            'Need for control may cause resistance to change',
          ],
          [
            'Accountability and diligence on personal commitments',
            'May reject opinions and observations that do not align with their own',
          ],
          [
            'Strong sense of ownership',
            'Can be superstitious about their choices',
          ],
        ],
      },
      // Table text 2-1
      {
        type: 'text',
        list: [],
        text: [
          {
            type: 'normal',
            title: '',
            content:
              `The Global Leadership Coaching process manages this paradigm by helping leaders
              rethink what they are doing. Just as our beliefs are among our strongest gifts,
              they can also create our biggest blind spots.
              The goal is not to forcefully rewire the leader but to maximize their level of
              commitment and persistence in areas that will benefit not only their organization,
              but also themselves as well.  As the leader will be choosing to work on
              their selected behaviors, they will bring a strong personal commitment,
              determination, and ownership to change those behaviors.
              Acknowledging the opinions of others and their own resistance to change will give the
              leader the power to take their effectiveness to the next level.`,
          },
        ],
      },
      // Paradigm 3
      {
        type: 'text',
        list: [],
        text: [
          // Paradigm 3-1
          {
            type: 'normal',
            title: 'PARADIGM 3 - I will succeed',
            content:
              `This is possibly the most important one of all.
              The first paradigm deals with the past, the second deals with the present,
              and the third paradigm “I will succeed” deals with the future.`,
          },
          // 3-2
          {
            type: 'normal',
            title: '',
            content:
              `Successful people have a record of past achievements that
              often feeds an unshakable belief in themselves.
              They tend to see a bright future,
              believing that they are in control of their own destiny
              - that if they put in the effort, they will overcome all obstacles.`,
          },
          // 3-3
          {
            type: 'normal',
            title: '',
            content:
              `The downside of this optimism and self-confidence is overcommitment.
              Successful people are chronically overcommitted.
              The nearly insatiable desire to play an active role in dictating our future,
              tends to skew our estimation of the capacity required to complete a task.
              The leader’s optimism, at some point, becomes a genuine liability. `,
          },
          // // 3-4
          // {
          //   type: 'normal',
          //   title: '',
          //   content:
          //     `Take Cheryl, for example. Cheryl was a brilliant,
          //       dedicated executive who consistently made her numbers.
          //       She was recognized for being smart, decisive, and highly capable.
          //       Life was pretty good for Cheryl, except for one thing: she was a steamroller.
          //       She frequently assumed a commanding role of projects without regard for
          //       who was really running the show.
          //       She believed that either projects will succeed because of her contributions or
          //       fail because of the lack thereof.`,
          // },
          // // 3-5
          // {
          //   type: 'normal',
          //   title: '',
          //   content:
          //     `When she received her 360 assessment people unanimously agreed about
          //       Cheryl the Steamroller.
          //       In her first session with her coach she was asked about this behavior.
          //       She said, “if I suddenly stop presenting my ideas then some other dumb idea is
          //       going to win and the person with the dumb idea will be in charge of
          //       the dumb project and will run it right into ground.”`,
          // },
          // // 3-6
          // {
          //   type: 'normal',
          //   title: '',
          //   content:
          //     `Cheryl, in this situation,
          //       was a highly competent executive but the consequences of this behavior
          //       far outweighs the short term success brought by her leadership.
          //       It is key to understand when to win and when not to win.`,
          // },
        ],
      },
      // Table 3
      {
        type: 'table',
        title: 'Takeaways',
        columns: [
          'Advantages',
          'Pitfalls',
        ],
        data: [
          [
            'Unflappable sense of optimism',
            'Face the danger of over-commitment',
          ],
          [
            'Persistent in the face of difficult odds',
            'Having to win at all cost; winning too much',
          ],
          [
            'Believe in their ability to create an impact',
            'Can have a hard time of “letting go” of failure',
          ],
        ],
      },
      // Table text 3-1
      {
        type: 'text',
        list: [],
        text: [
          {
            type: 'normal',
            title: '',
            content:
              `Take Bill, for example, who learned this the hard way.
              He was the CEO of one of the world’s largest non-profit organizations.
              His biggest problem by far?  Overcommitting himself and his people.
              He couldn’t say no and this led to a high rate of turnover and burnout
              - in spite of the great work his organization was doing.
              On his behavioral assessment he received an average of 1.2 out of 5 on the item
              “Clearly communicates priorities.”
              His mission was to help the most vulnerable people in the world.
              His coach had to tell him, “Your goal is to help the most vulnerable,
              not create the most vulnerable.”  The CEO so much believed “I will succeed” that
              he tended to overcommit himself and, given that he led others in the organization,
              he tended to overcommit everyone else as well.`,
          },
        ],
      },
      // Table text 3-2
      {
        type: 'text',
        list: [],
        text: [
          {
            type: 'normal',
            title: '',
            content:
              `Fortunately, his “I will succeed” paradigm gave him optimism to believe that
              he could enact change.
              He asked for suggestions from his team and worked with his coach to determine
              just 1 or 2 things he could do to turn it around.
              Here’s what happened: The CEO started carrying a notecard in his wallet with
              the major projects that he and his team were responsible for.
              Before committing to take on any more work,
              he simply took the notecard out of his wallet and wrote down
              whatever the new task was.  During the next executive roundtable,
              he would read what was written on the card and the team would jointly decide
              what their capacity allowed.  After just 6 months of coaching, his score for
              “Clearly communicates priorities” went from a 1.2 out of 5 to a 4.7 out of 5.`,
          },
        ],
      },
      // Table text 3-3
      {
        type: 'text',
        list: [],
        text: [
          {
            type: 'normal',
            title: '',
            content:
              `With this unwavering belief, “I will succeed,”
              leaders are able to persist toward their goals, overcome challenges along the road,
              and trust themselves to reach their goal.
              They are not likely to view outside circumstances as reasons to quit,
              and often gain a positive reputation for being diligent and optimistic.
              Leaders need to capitalize on the advantages of this paradigm,
              and orchestrate around the pitfalls.`,
          },
        ],
      },
      // Paradigm 4 - Benefits of Involving Stakeholders
      {
        type: 'text',
        list: [],
        text: [
          // 4-1
          {
            type: 'normal',
            title: 'Benefits of Involving Coworkers',
            content:
                `Each of the 3 paradigms comes with its inherent obstacles
                - whether it is the ego that makes it difficult to ask for and receive suggestions
                from others, or the thought that one has succeeded because of
                certain behaviors rather than in spite of them.`,
          },
          // 4-2
          {
            type: 'normal',
            title: '',
            content:
                `The good news is that each of these obstacles can be almost entirely mitigated
                by involving coworkers. Involving coworkers requires courage to face
                weaknesses and ask for suggestions. It requires humility to listen,
                take into consideration the suggestions, and ask for accountability in
                making those changes. Finally, involving coworkers requires discipline to
                turn their suggestions into visible action on a daily basis.`,
          },
          // 4-3
          {
            type: 'normal',
            title: '',
            content:
                `The same paradigms that have helped us in the past are hindering us in the present.
                They can be used to help you achieve your goals
                if they are actively and appropriately managed.
                The most important action you can take is to identify and reflect on the areas that
                resonate with us, and to foster the courage, humility,
                and discipline to commit to positive behavioral change.`,
          },
        ],
      },
    ],
    replenish: '',
    buttons: [
      {
        type: 'primary',
        title: 'Close',
        key: 'close:',
      },
    ],
  },
  // 5
  {
    type: 'stak',
    header: {
      title: 'COWORKER ONBOARDING',
      description: [
        {
          type: 'normal',
          content:
              `Now that you’ve selected your coworkers and your growth areas,
              it's time to share your action plan with them.
              Take 2-3 minutes over the next week
              to speak with each of your selected coworkers and
              let them know about the coaching process, why they’ve been selected,
              and what their role will be. You may also want to share a few of the ways
              they’ll benefit and encourage them to hold you accountable to your commitments.`,
        },
        {
          type: 'normal',
          content:
              `Here is an example of a conversation a leader might have
              with one of their coworkers.`,
        },
      ],
      media: [
        {
          type: 'audio',
          data: 'https://mg-coaching.s3.ap-northeast-2.amazonaws.com/Assets/Stakeholder+Onboarding.mp3',
        },
      ],
    },
    bodyType: '',
    bodies: [
      {
        type: 'text',
        list: [],
        text: [
          // Charles 1
          {
            type: 'normal',
            title: 'Charles:',
            content: 'Hi Melissa',
          },
          // Melissa 1
          {
            type: 'normal',
            title: 'Melissa:',
            content: 'Hello Charles',
          },
          // Charles 2-1
          {
            type: 'normal',
            title: 'Charles:',
            content:
                `Thank you for taking time to meet with me.
                I wanted to take a few minutes and share something important with you.
                Over the next 6 months,
                I will be going through a coaching program to develop my leadership skills.
                Based on the feedback I’ve received,
                I’m committing to developing myself in 2 leadership areas:
                better delegation and more engaging communication.
                These are two areas where my development can have a positive impact
                on our team performance and hopefully make the workplace even more enjoyable
                for others.`,
          },
          // Charles 2-2
          {
            type: 'normal',
            title: '',
            content:
                `But, I realize that if I’m going to get better at this, I’ll need help.
                Specifically yours and others that I communicate and work with regularly.
                Would you be willing to support me in this journey?
                It will require just 2 minutes a month from you.`,
          },
          // Melissa 2
          {
            type: 'normal',
            title: 'Melissa:',
            content: 'Yes, of course. I’d love to help. How can I support you?',
          },
          // Charles 3
          {
            type: 'normal',
            title: 'Charles:',
            content:
                `Once a month I will be asking you for Feedforward.
                Feedforward is a suggestion that is future focussed:
                so in this case, what can I do to improve over the next 30 days?`,
          },
          // Charles 3-2
          {
            type: 'normal',
            title: '',
            content:
                `As part of the coaching,
                I’ll be using an online platform that will automatically send you an email
                once a month asking you for a couple of suggestions on
                how I can be more effective in my 2 growth areas.
                I’ll use the Feedforward suggestions from you, and a few other coworkers,
                to make an action plan.
                I’ll share that with you so you can see what I’m working on.`,
          },
          // Charles 3-3
          {
            type: 'normal',
            title: '',
            content:
                `The second way you can help is by providing feedback on my progress.
                So, once a quarter, the platform will send you a survey about
                how I’ve been doing for the past three months in these two specific areas.
                The survey is completely anonymous and takes only a couple of minutes.`,
          },
          // Melissa 3
          {
            type: 'normal',
            title: 'Melissa:',
            content:
                `So just to clarify, once a month
                I’ll get an email that asks for a couple of Feedforward
                suggestions...and...Feedforward is...suggestions for the future,
                right?`,
          },
          // Charles 4
          {
            type: 'normal',
            title: 'Charles:',
            content:
                `Yes exactly.
                And that gives me clear targets on
                how I can improve in ways that are important to you and others.`,
          },
          // Melissa 4
          {
            type: 'normal',
            title: 'Melissa:',
            content:
                `And every 3 months,
                I’ll get a survey on whether you are becoming more effective.
                Is that right?`,
          },
          // Charles 5
          {
            type: 'normal',
            title: 'Charles:',
            content: 'You got it, Melissa.',
          },
          // Melissa 5
          {
            type: 'normal',
            title: 'Melissa:',
            content: 'Great, sounds fantastic.',
          },
          // Charles 6
          {
            type: 'normal',
            title: 'Charles:',
            content:
                `Thank you. This means a lot to me and should help me become a better coworker.
                I want to be very transparent with everyone about what I am working on.
                I hope that it will make us a tighter team and will help me make
                this an even better place to work.
                I really appreciate your support.`,
          },
        ],
      },
    ],
    replenish: '',
    buttons: [
      {
        type: 'primary',
        title: 'Close',
        key: 'close:',
      },
    ],
  },
  // 6
  {
    type: 'pulseBenefit',
    header: {
      title: 'PULSE PROCESS & BENEFITS',
      description: [
        {
          type: 'normal',
          content:
            ` How do I know when I’ve been successful in becoming a better leader?
              And precisely how much progress have I made?`,
        },
      ],
      media: '',
    },
    bodyType: '',
    bodies: [
      {
        type: 'text',
        list: [],
        text: [
          {
            type: 'normal',
            title: '',
            content:
              `These questions are frequently asked by leaders
              receiving coaching but are difficult to answer.
              Global Coach Group's 360 Feedforward Coaching process,
              however, is able to answer these questions with
              unprecedented clarity of your progress as a leader with a survey called the Pulse.
              Every 3 months, the platform sends a brief survey about
              the progress of your leadership to each coworker via email.
              The platform then generates a report with the data collected from the surveys,
              which your coach will review with you in your following session.`,
          },
          {
            type: 'normal',
            title: '',
            content:
              `The Pulse is launched and runs automatically on the platform.
              It will also remind coworkers to complete the survey if they have not done
              so within a certain period of time.
              We recommend personally informing your coworkers of their
              upcoming participation as the platform will be sending out emails
              during the Pulse.`,
          },
        ],
      },
    ],
    replenish: '',
    buttons: [
      {
        type: 'primary',
        title: 'Close',
        key: 'close:',
      },
    ],
  },
  // 7
  {
    type: 'reviewSession',
    header: {
      title: 'PREPARING FOR YOUR LAST SESSION WITH HR & LM',
      description: [
        {
          type: 'normal',
          content:
            ` Missing
            content`,
        },
      ],
      media: '',
    },
    bodyType: '',
    bodies: [
      {
        type: 'text',
        list: [],
        text: [
          {
            type: 'normal',
            title: '',
            content:
              `Missing
              content`,
          },
        ],
      },
    ],
    replenish: '',
    buttons: [
      {
        type: 'primary',
        title: 'Close',
        key: 'close:',
      },
    ],
  },
];
